// extracted by mini-css-extract-plugin
export var borderRadius = "_ef-4";
export var large = "_ef-3";
export var logoContainer = "_ef-0";
export var nameLogo = "_ef-2";
export var small = "_ef-1";